import { FC, useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

import './index.css'
import HomeService from "../../../../shared/services/home";
import { ErrorResults, Loading } from "../../../../shared/components";
import { Spin } from "antd";
import { COLORS } from "../../../../config/themes/colors";
import { CustomTooltip } from "../../../../shared/components/Charts";

interface PieChartValues {
    name: string;
    value: number;
}

export const PieChartHome: FC = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [currentWallet, setCurrentWallet] = useState<PieChartValues[]>([]);
    const [showErrorPieChart, setShowErrorPieChart] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getCurrentWallet = async () => {
        setIsLoading(true);
        try {
            const response = await HomeService.getCurrentWallet();
            setCurrentWallet(
                response.gruposDeRama.map((item) => ({
                    name: item.descripcion,
                    value: parseInt(item.porcentaje!),
                }
            )));
        } catch (error) {
            setShowErrorPieChart(true);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getCurrentWallet();
    }, []);

    const COLORS_ = [
        COLORS.primary[50],
        COLORS.accents.yellow_ochre[50],
        COLORS.accents.light_blue[100],
        COLORS.accents.dark_red[100],
    ];

    const RADIAN = Math.PI / 180;

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {        
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
      
        return (
          <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
          </text>
        );
    };

    return (
        isLoading ?
        <div className="pie-chart-loading-container">
            <Spin size="large" /> 
        </div> :
        showErrorPieChart ? <ErrorResults title="No se pudo cargar el grafico de Cartera Vigente" /> :
            <ResponsiveContainer height="100%">
                <PieChart width={1700} height={1700}>
                    <Pie
                        data={currentWallet}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        fill="#8884d8"
                        dataKey="value"
                        onMouseEnter={(_, index) => setActiveIndex(index)}
                        onMouseLeave={() => setActiveIndex(null)}
                        activeIndex={activeIndex!}
                        activeShape={{
                            opacity: 0.8,
                        }}
                        stroke="none"
                    >
                        {currentWallet.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS_[index % COLORS_.length]} />
                        ))}
                    </Pie>
                    <Tooltip
                        content={(props) => {
                            const payload = props.payload?.[0];
                            return (
                                <CustomTooltip
                                label={payload ? payload.name?.toString() || '' : ''}
                                hoveredElement={props.payload}
                                />
                            );
                        }}
                    />
                    <Legend 
                        verticalAlign="top" 
                        align="right" 
                        layout="vertical" 
                        iconType="square" 
                        iconSize={9}
                        wrapperStyle={{ fontSize: '15px', color: "black", marginBottom: '10px' }} 
                    />
                </PieChart>
            </ResponsiveContainer>
    );
}
